export default __webpack_public_path__ + "static/media/about1.6e846e8d.svg";